export const downloadCSV = async ({ rootGetters }, {
    payload
}) => {
    const organizationId = rootGetters['app/getSelectedOrganization'].id

    const jsonPayload = encodeURIComponent(JSON.stringify(payload))

    window.open('/downloads/csv-swaps?_=' + `${jsonPayload}&organizationId=${organizationId}`)
}